'use client'
import { useTheme } from "next-themes";
import { Moon, Sun } from "@/assets/icons";
import { Button, Spinner } from "@/components/ui";
import { useState, useEffect } from "react";

export function ChangeMode() {
    const { theme, setTheme } = useTheme();
    const [isForcedDark, setIsForcedDark] = useState(false);
    const [mounted, setMounted] = useState(false);

    const isLight = theme === "light";

    // Verifica se navegador está forçando escuro
    useEffect(() => {
        setMounted(true);
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        setIsForcedDark(mediaQuery.matches);

        // Opcional: listener para mudanças
        const handler = (e: MediaQueryListEvent) => setIsForcedDark(e.matches);
        mediaQuery.addEventListener('change', handler);
        return () => mediaQuery.removeEventListener('change', handler);
    }, []);

    // Evita renderização diferente no server
    if (!mounted) {
        return (
            <Button disabled >
                <Spinner className="size-6 border-2" />
                <p>Carregando...</p>
            </Button>
        );
    }

    if (isForcedDark) {
        return (
            <Button disabled >
                <Moon className="size-6" />
                <p>Tema escuro (sistema)</p>
            </Button>
        );
    }

    return (
        <Button
            aria-label="Change theme"
            onClick={() => setTheme(isLight ? "dark" : "light")}>
            {isLight ? <Moon className="size-6" /> : <Sun className="size-6" />}
            <p>Alterar para tema {isLight ? "escuro" : "claro"}</p>
        </Button>
    )
}